import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ToastProvider } from "./components/Toast";
import { VaultGate } from "./components/VaultGate";
import { BrowserRouter } from "./lib/router";
import { registerPwa } from "./pwa";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <VaultGate>
          <App />
        </VaultGate>
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
);

void registerPwa();
